export default __webpack_public_path__ + "pgnv-assets/9dc6398f3981f00d610e11e21a2f8b61.png";